import PrevadzkovaKnihaSections from "./PrevadzkovaKnihaSections"

export default class PrevadzkovaKnihaCtrl {

  static resolve = {
    kniha: (PrevadzkovaKnihaService, $stateParams) => PrevadzkovaKnihaService.getRecord($stateParams.id),
    logSource: (PrevadzkovaKnihaService, $stateParams) => PrevadzkovaKnihaService.getLogSource($stateParams.id).wait()
  }

  constructor(kniha, logSource, PrevadzkovaKnihaZaznamModal, AuthService, PrevadzkovaKnihaService, PrevadzkovaKnihaPrintModal, $timeout){
    this.item = kniha;
    this.PrevadzkovaKnihaService = PrevadzkovaKnihaService;
    this.logSource = logSource;
    this.PrevadzkovaKnihaZaznamModal = PrevadzkovaKnihaZaznamModal;
    this.PrevadzkovaKnihaPrintModal = PrevadzkovaKnihaPrintModal;
    this.auth = AuthService;
    this.$timeout = $timeout;
    this.tabs = {
      obalka: {
        icon: "fa fa-book",
        title: "Obálka"
      },
      zakon: {
        icon: "i-§",
        title: "Zákonné informácie"
      },
      objekt: {
        icon: "fa fa-bank",
        title: "Informácie o objekte"
      },
      pokyny: {
        icon: "fa fa-info-circle",
        title: "Pokyny"
      },
      zaznamy: {
        icon: "fa fa-pencil",
        title: "Záznamy"
      }
    }
    this.activeTab = this.tabs.obalka;
//    this.activeTab = this.tabs.zaznamy;
    this.sections = PrevadzkovaKnihaSections;

    this.logOptions = this.PrevadzkovaKnihaService.getLogOptions(this.item.data.acl);
    this.canMonthlyCheck = this.logOptions.filter(o => o.value == 1).length > 0;
    this.canQuarterlyCheck = this.logOptions.filter(o => o.value == 2).length > 0;
    this.canYearlyCheck = this.logOptions.filter(o => o.value == 3).length > 0;

  }

  addLog(){   
    this.PrevadzkovaKnihaZaznamModal(this.logOptions, {pocitadloPoplachov: this.item.data.pocitadloPoplachov}).result.then(zaznam => {
      return this.item.resource.call("log", {
        id: this.item.data.id,
        typ: zaznam.typ,
        data: zaznam.data
      }).then(
        () => {
          this.logSource.load()
          this.item.load()
        },
        GlobalErrorHandler
      );
    });
  }

  cancelLog(log){
    if(!window.confirm("Naozaj vyškrtnúť záznam? Táto akcia sa nedá vrátiť spať.")) return;
    return this.PrevadzkovaKnihaService.cancelLog(log.id).then(x => {
      return this.logSource.load();
    })
  }

  print(){
    this.PrevadzkovaKnihaPrintModal().result.then(data => {
      this.logSource.limit = 9999;
      this.logSource.filter = data;
      this.logSource.filter.knihaId = this.item.data.id;
      return this.logSource.load()
    })
    .then(() => this.$timeout())
    .then(() => {
      return new Promise((resolve) => {
        var fn = () => {
          window.removeEventListener("afterprint", fn);
          resolve();
        }
        window.addEventListener("afterprint", fn);
        window.print();
      })
    }).then(() => {
      console.log("done");
      this.logSource.filter = {};
      this.logSource.filter.knihaId = this.item.data.id;
      this.logSource.limit = 10;
      this.logSource.load();
    })
  }

}


// WEBPACK FOOTER //
// ./src/prevadzkova-kniha/PrevadzkovaKnihaCtrl.js